function onEntry(entry:any){
    entry.forEach((change:any)=>{
        if(change.isIntersecting){
            change.target.classList.add('element-show');
        }
    });
}



let options={
    threshold:[0.5]};
let observer= new IntersectionObserver(onEntry,options);


export const init=(elements:any)=>{
    for(let elm of elements){
        console.log('ghergerg')
        observer.observe(elm);
    }
}

//init()

